import { dataHooks } from '@wix/data-hooks';

export const recommendedArticlesDataHooks = dataHooks<{
  loader;
  container;
  item: { id: string };
}>('recommendedArticles');
